import { render, staticRenderFns } from "./VueEditor.vue?vue&type=template&id=386d1ba4"
import script from "./VueEditor.vue?vue&type=script&lang=js"
export * from "./VueEditor.vue?vue&type=script&lang=js"
import style0 from "./VueEditor.vue?vue&type=style&index=0&id=386d1ba4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports